/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    maxHeight: {
      description: 'Whether MultiselectFilter modal should expand responsively to content or a set maximu height',
      type: 'state',
      values: [ true ]
    },
    maxWidth: {
      description: 'Whether MultiselectFilter modal should expand to content or a set maximuh width',
      type: 'state',
      values: [ true ]
    },
    selected: { type: 'state', values: [ true ] },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        buttonDirection: 'column',
        minHeight: '100%',
        minWidth: '100%'
      }
    },
    {
      if: { maxHeight: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
      tokens: { maxHeightSize: 480 }
    },
    {
      if: { maxWidth: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
      tokens: { maxWidthSize: 544 }
    },
    {
      if: { selected: true },
      tokens: { buttonIconBackgroundColor: '#f4f4f7', labelColor: '#676e73' }
    }
  ],
  tokens: {
    buttonBackgroundColor: '#ffffff',
    buttonBackgroundColorSelected: '#ffffff',
    buttonBorderColor: '#b2b9bf',
    buttonDirection: 'row',
    buttonIconBackgroundColor: '#f4f4f7',
    buttonIconPadding: 2,
    buttonIconSize: 16,
    containerBorderColor: '#e3e6e8',
    contentMarginBottom: 32,
    contentMarginLeft: 16,
    contentMarginRight: 16,
    contentMarginTop: 24,
    contentPaddingLeft: 16,
    contentPaddingRight: 16,
    dividerColor: '#e3e6e8',
    headerFontColor: '#414547',
    headerFontName: 'HNforTELUSSA',
    headerFontSize: 16,
    headerFontWeight: '500',
    headerLineHeight: 1.5,
    iconColor: '#414547',
    iconColorSelected: '#414547',
    labelColor: '#676e73',
    labelFontName: 'HNforTELUSSA',
    labelFontSize: 14,
    labelFontWeight: '700',
    labelLineHeight: 1.42857142857,
    labelPaddingBottom: 8,
    labelPaddingLeft: 16,
    labelPaddingRight: 8,
    labelPaddingTop: 8,
    maxHeightSize: 480,
    maxWidthSize: 0,
    minHeight: 0,
    minWidth: 320,
    subHeaderFontName: 'HNforTELUSSA',
    subHeaderFontSize: 14,
    subHeaderFontWeight: '400',
    subHeaderLineHeight: 1.4
  }
}
export default theme
